import React from 'react';
import styles from './W_TitleSign.module.css';
import A_Logo from '@/components/A_Atoms/A_Logo/A_Logo';
import cn from 'classnames';
import { getTranslation } from '@/constants/translations';
import { useLanguage } from '@/contexts/LanguageContext';

interface W_TitleSignProps {
  variant: 'login' | 'register';
  onSwitchVariant: () => void;
}

export default function W_TitleSign({
  variant,
  onSwitchVariant,
}: W_TitleSignProps) {
  const isLogin = variant === 'login';
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  const title = isLogin ? t('auth.loginTitle') : t('auth.registerTitle');

  const renderSubtitle = () => {
    if (isLogin) {
      return (
        <>
          {t('auth.newUser')}{' '}
          <button
            type='button'
            className={cn(styles.button, 'text-p-5')}
            onClick={onSwitchVariant}
          >
            {t('auth.account')}
          </button>
        </>
      );
    } else {
      return (
        <>
          {t('auth.haveAccount')}{' '}
          <button
            type='button'
            className={cn(styles.button, 'text-p-5')}
            onClick={onSwitchVariant}
          >
            {t('auth.login')}
          </button>
        </>
      );
    }
  };

  return (
    <div className={styles.wrapper}>
      <A_Logo variant='default' />
      <h1>{title}</h1>
      <p className='text-p-6'>{renderSubtitle()}</p>
    </div>
  );
}
